import { render, staticRenderFns } from "./params.vue?vue&type=template&id=4504f1f7"
import script from "./params.vue?vue&type=script&lang=ts"
export * from "./params.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports